module.exports = __webpack_public_path__ + "static/img/3.5e77496.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-hogar/3.png
// module id = F4n/
// module chunks = 0